import * as R from 'ramda';
import actions from './actions';
import {select, call, put, takeEvery, takeLatest} from 'redux-saga/effects';
import {CRUD_GET_ONE_SUCCESS} from 'react-admin';
import {dataProvider} from '../../App';


export function fetchConsumerUserData(patientId) {
    return dataProvider(actions.PATIENT_INFO_LOAD_START, 'patients', {patientId})
        .then(({data}) => {
            return Promise.resolve(data);
        })
        .catch(() => {
            return Promise.resolve(null);
        })
}

function* handlePatientViewLoad(action) {
    const resource = R.pathOr(null, ['meta', 'resource'], action);
    if (resource === 'patients') {
        const patientId = R.pathOr(null, ['requestPayload', 'id'], action);
        if (patientId) {
            const record = R.pathOr(null, ['payload', 'data'], action);
            if (record && record.auth_token) {
                const consumerInfo = yield call(fetchConsumerUserData, patientId);
                if (consumerInfo) {
                    yield put(actions.updateConsumerInfo(patientId, consumerInfo));
                }
            }
        }
    }
}


export default function* patientSaga() {
    yield takeLatest(CRUD_GET_ONE_SUCCESS, handlePatientViewLoad);
}
